import { useMemo } from "react";

import { ListViewType } from "@/constants";

import { FilterFieldKey, FilterOptions } from "../typing";

const useFilterCondition = (
  filterOptions: FilterOptions,
  listViewType?: number
): Partial<Record<FilterFieldKey, boolean>> => {
  const isGridMode = listViewType === ListViewType.Grid;
  return useMemo(() => {
    const premiumRange = filterOptions?.premiumRange;
    return {
      premium: !isGridMode && (premiumRange ? premiumRange[0] < premiumRange[1] : false),
      date: filterOptions?.datesOptions?.length > 1,

      maxPoints: !isGridMode,
      tax: !isGridMode,
      cabins: !isGridMode,
      gridModeMaxPoints: isGridMode,
      gridModeTax: isGridMode,
      gridModePremium: isGridMode,
      gridModeCabins: isGridMode,
    };
  }, [filterOptions, isGridMode]);
};

export default useFilterCondition;
